module.exports = __webpack_public_path__ + "media/game-over.b822e371.wav";